import { Capacitor } from '@capacitor/core'

export const isNative = Capacitor.isNativePlatform()

/**
 * Open a URL (presigned S3 document, Convex attachment, …) in the native
 * document viewer via a temp download that is cleaned up after the viewer
 * closes. Returns false on web so callers can fall back to a browser flow.
 */
export async function openWithNativeViewer(url: string, fileName?: string): Promise<boolean> {
  if (!isNative) return false
  try {
    const { Filesystem, Directory } = await import('@capacitor/filesystem')
    const { FileTransfer } = await import('@capacitor/file-transfer')
    const { FileViewer } = await import('@capacitor/file-viewer')

    const name = fileName || 'file'
    const tempPath = `tmp_viewer_${Date.now()}_${name}`

    const { uri } = await Filesystem.getUri({
      directory: Directory.Cache,
      path: tempPath,
    })

    const result = await FileTransfer.downloadFile({
      url,
      path: uri,
    })

    try {
      await FileViewer.openDocumentFromLocalPath({ path: result.path! })
    } finally {
      // The viewer has its own copy once opened; don't let temp files pile up.
      void Filesystem.deleteFile({ path: tempPath, directory: Directory.Cache }).catch(() => {})
    }

    return true
  } catch (e) {
    console.error('Native file viewer failed:', e)
    return false
  }
}
